// authorized requests
import '@/utils/initializeLocalStorage'
import axios from 'axios'

const BACKOFFICE = process.env.VUE_APP_BACKOFFICE_URL || 'http://localhost:82/'

export default {
  namespaced: true,
  state: {
    access: localStorage.getItem('pn_auth_access') || false,
  },
  mutations: {
    setToken(state, jwt) {
      localStorage.setItem('pn_auth_access', jwt)
      state.access = jwt
    },
  },
  actions: {
    createPaymentArticle({ state, dispatch }, { id = -1 }) {
      if (id === -1)
        dispatch(
          'layout/showMessage',
          {
            title: 'Error while creatingPayment',
            message: 'Wrong id',
          },
          { root: true }
        )

      return axios
        .post(
          `${BACKOFFICE}payments/article`,
          {
            id: id,
          },
          {
            headers: {
              Authorization: `Bearer ${state.access}`,
            },
          }
        )
        .then((res) => res.data)
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error while starting payment',
              message: String(err),
              type: 'error',
              timeout: 5000,
            },
            { root: true }
          )
          throw err
        })
    },
    getArticles({ state, dispatch }, { lang }) {
      let obj = {
        params: { lang },
      }
      if (state.access)
        obj.headers = { Authorization: `Bearer ${state.access}` }
      return axios
        .get(`${BACKOFFICE}articles`, obj)
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error while getting articles',
              message: String(err),
              type: 'error',
              timeout: 5000,
            },
            { root: true }
          )
          throw err
        })
        .then((res) => res.data)
    },
    getArticle({ state, dispatch }, { slug, lang }) {
      // TODO: make universal check authorization .get -> .ac_get(state)(URL)
      let obj = {
        params: { lang },
      }
      if (state.access)
        obj.headers = { Authorization: `Bearer ${state.access}` }
      return axios
        .get(`${BACKOFFICE}articles/${slug}`, obj)
        .catch((err) => {
          dispatch(
            'layout/showMessage',
            {
              title: 'Error while getting the article',
              message: String(err),
              type: 'error',
              timeout: 5000,
            },
            { root: true }
          )
          throw err
        })
        .then((res) => res.data)
    },
  },
}
